import React from 'react'
import { Card, CardBody, CardFooter, Col, Row } from 'reactstrap'
import { Rating } from 'react-simple-star-rating'
import { H4, Image, LI, P, UL } from '../../../AbstractElements'
import { FeaturedTutorialsTitle } from '../../../Utils/Constants'
import { featuredTutorialsData } from '../../../Data/MiscellaneousData/FaqData'
import { dynamicImage } from '../../../Utils'

export default function FeaturedTutorials() {
    return (
        <Col lg={12}>
            <div className="header-faq"><H4 className="mb-0">{FeaturedTutorialsTitle}</H4></div>
            <Row>
                {featuredTutorialsData.map((data) => (
                    <Col xl={3} md={6} className="xl-50 box-col-6" key={data.id}>
                        <Card className="features-faq product-box">
                            <div className="faq-image product-img">
                                <Image className="img-fluid" src={dynamicImage(`faq/${data.image}`)} alt="" />
                                <div className="product-hover">
                                    <UL className='simple-list flex-row'>
                                        <LI><i className="icon-link"></i></LI>
                                        <LI><i className="icon-import"></i></LI>
                                    </UL>
                                </div>
                            </div>
                            <CardBody>
                                <H4 className="f-w-600">{data.title}</H4>
                                <P>{data.description}</P>
                            </CardBody>
                            <CardFooter>
                                <span>{'Dec 15, 2023'}</span>
                                <span className="pull-right"><Rating fillColor="#008dab" initialValue={Math.random() * 5} size={14} /></span>
                            </CardFooter>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Col>
    )
}
